import React, { useState } from 'react';
import { useParams } from 'react-router';
import ActionsTable from './ActionsTable';
import ActionsKanban from './ActionsKanban';
import ActionDrawer from './ActionDrawer';
import { INCIDENT } from './ICSConstants';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { StylishNewToggleButtonGroup } from '../DesignSystems/New/StylishNewToggleButtonGroup';
import PageTitle from '../headers/PageTitle';
import MobileWarningDialog from 'components/DesignSystems/MobileWarning/MobileWarningDialog';
import { useViewState } from './hooks/useViewState';

import { useIcsFormPdfPreview } from 'components/IAP/context/IcsFormPdfPreviewContext';
import { SharedIcon } from '../SharedIcon/SharedIcon';

const viewOptions = [
  { label: 'Table', value: 'table' },
  { label: 'Kanban', value: 'kanban' },
];

// TODO (aeortic): we can't access this componnent in the platform, so we should remove it.
// The route that this sits behind exists, but there is no navigation that takes the user there.
const ActionsPage: React.FC = () => {
  const { incidentId } = useParams<{ incidentId: string }>();
  const { activeView, setActiveView } = useViewState({
    storageKey: 'actions-view-preference',
  });
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [selectedAction, setSelectedAction] = useState<any>(null);

  const { exportAsForm } = useIcsFormPdfPreview();

  const handleAddAction = () => {
    setShowAddDrawer(true);
  };

  const handleEditAction = (action: any) => {
    setSelectedAction(action);
    setShowEditDrawer(true);
  };

  const handleExportICS233 = () => {
    void exportAsForm({
      formname: 'ICS_233_CG',
      data: {},
      mapSketch: null,
    });
  };

  if (!incidentId) {
    return <div>No incident ID provided</div>;
  }

  return (
    <MobileWarningDialog>
      <div className="maincontent">
        <PageTitle title="Actions">
          <div className="d-flex gap-3 align-items-center">
            <StylishNewToggleButtonGroup
              data={viewOptions}
              selected={activeView}
              onChange={setActiveView}
            />
            <StylishNewButton
              className="button--secondary"
              onClick={handleExportICS233}
            >
              <SharedIcon iconName="download" classes="me-2" />
              Preview ICS 233
            </StylishNewButton>
            <StylishNewButton
              className="button--primary"
              onClick={handleAddAction}
            >
              <SharedIcon iconName="add" classes="me-2" />
              Add Action
            </StylishNewButton>
          </div>
        </PageTitle>

        {activeView === 'table' ? (
          <ActionsTable scope={INCIDENT} onEditAction={handleEditAction} />
        ) : (
          <ActionsKanban
            incidentId={incidentId}
            onEditAction={handleEditAction}
          />
        )}

        {showAddDrawer && (
          <ActionDrawer
            scope={INCIDENT}
            toggle={() => setShowAddDrawer(false)}
          />
        )}

        {showEditDrawer && selectedAction && (
          <ActionDrawer
            scope={INCIDENT}
            toggle={() => setShowEditDrawer(false)}
            selectedEntity={selectedAction}
          />
        )}
      </div>
    </MobileWarningDialog>
  );
};

export default ActionsPage;
